// extracted by mini-css-extract-plugin
export var alignCenter = "_7u-d";
export var bannerShown = "_7u-6";
export var buttonContent = "_7u-0";
export var cardList = "_7u-1";
export var centerContent = "_7u-2";
export var chevron = "_7u-3";
export var closePanelButton = "_7u-k";
export var conversationContextContainer = "_7u-l";
export var conversationDetailContainer = "_7u-4";
export var detailWrapper = "_7u-7";
export var dropdownButton = "_7u-e";
export var dropdownTitle = "_7u-9";
export var fullHeight = "_7u-5";
export var hidden = "_7u-a";
export var icon = "_7u-b";
export var mergeSuggestionWrapper = "_7u-m";
export var panel = "_7u-i";
export var portalButtonsWrapper = "_7u-c";
export var right = "_7u-j";
export var tableSummaryContainer = "_7u-8";
export var tableSummaryHeader = "_7u-g";
export var threeDotsButton = "_7u-f";
export var wide = "_7u-h";